export enum HardnessFactor {
  HBW = 'hbw',
  HBS = 'hbs',
  HRB = 'hrb',
  HRC = 'hrc',
  HRA = 'hra',
  userHra = 'userHra'
}
export type Hardness = Partial<Record<HardnessFactor, number>>;
